import { Image } from '@/components/Image'
import { BodyM, HeadingL } from '@/components/Typography'

import { CONTAINER_BLACK_FRIDAY_PROPS } from '../constants'
import { Disclaimer } from '../Disclaimer'
import { DISCLAIMER_TEXTS } from '../Disclaimer/constants'

import { MEDIA_WITH_ICONS } from './constants'
import { IconListItem } from './IconListItem'

import {
  IconList,
  SectionButtonLink,
  SectionContainer,
  SectionContentContainer,
  SectionFooter,
  SectionImageContainer,
  SectionTextContainer,
} from './styles'

const MediaWithIcons = () => (
  <SectionContainer {...CONTAINER_BLACK_FRIDAY_PROPS} contentClassName="media-with-icons-content">
    <SectionImageContainer>
      <Image {...MEDIA_WITH_ICONS.image} alt="Juiz apitando com cartão vermelho na mão" />
    </SectionImageContainer>
    <SectionContentContainer>
      <SectionTextContainer>
        <HeadingL light="solid" tag="h2">
          Consulta de dados na Dark Web
        </HeadingL>
        <BodyM light="solid">
          Saiba se os seus dados foram parar no lugar mais perigoso da internet e fique um passo à
          frente da ação de fraudadores.
        </BodyM>
      </SectionTextContainer>
      <IconList aria-label="Na Serasa você consegue consultar: ">
        {MEDIA_WITH_ICONS.icons.map((icon) => (
          <IconListItem key={icon.id} {...icon} />
        ))}
      </IconList>
      <SectionButtonLink
        rounded
        aria-label="Consultar dados na Dark Web"
        source={MEDIA_WITH_ICONS.cta.href}
        modifier="solid"
      >
        Consultar
      </SectionButtonLink>
      <SectionFooter>
        <Disclaimer
          id="mwi-footer-disclaimer"
          text={DISCLAIMER_TEXTS.darkWebConsulting.text}
          accessibleText={DISCLAIMER_TEXTS.darkWebConsulting.accessibleText}
          light="solid"
          className="media-with-icons__footer__disclaimer"
        />
      </SectionFooter>
    </SectionContentContainer>
  </SectionContainer>
)

export default MediaWithIcons
